module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_with_quests.d1a8e7c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_with_quests.jpg
// module id = 3038
// module chunks = 11